import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default class Animations {
    constructor() {
        this.triggerStart = 'top +=65%';
        this.triggerEnd = 'bottom -65%';
        this.animationBlocks = document.querySelectorAll('[data-block-animate]');
        this.animateOnLoadBlocks = document.querySelectorAll('[data-animate-on-load]');
        if (window.innerWidth < 772) {
            this.triggerStart = 'top +=85%';
            this.triggerEnd = 'bottom -85%';
        }
        if (this.animationBlocks.length) {
            this.init();
        }
        if (this.animateOnLoadBlocks.length) {
            this.animateOnLoad();
        }
    }
    init() {
        const self = this;
        this.animationBlocks.forEach(animationBlock => {
            const contentParts = animationBlock.querySelectorAll('[data-animate-part]');
            ScrollTrigger.create({
                trigger: animationBlock,
                start: self.triggerStart,
                end: self.triggerEnd,
                once: true,
                //markers: true,
                onEnter: (self) => {
                    gsap.fromTo(animationBlock, { autoAlpha: 0 }, { autoAlpha: 1, duration: 1 });
                    if (contentParts.length) {
                        gsap.fromTo(contentParts, { autoAlpha: 0, y: 50 }, {
                            autoAlpha: 1,
                            y: 0,
                            delay: 0.3,
                            duration: 1,
                            stagger: 0.1
                        });
                    }
                },
            });
        });
    }
    animateOnLoad() {
        const scaleDown = document.querySelector('[data-animate-scale-down]');
        const fadeUp = document.querySelector('[data-animate-on-load-fade-up]');
        window.addEventListener('load', () => {
            gsap.fromTo(scaleDown, { scale: 1.2 }, { scale: 1, duration: 1 });
            gsap.fromTo(fadeUp, { autoAlpha: 0 }, { autoAlpha: 1, duration: 1 });
            this.animateOnLoadBlocks.forEach(block => {
                gsap.to(block, { autoAlpha: 1, duration: 1 });
            });
        });
    }
}
